import { readItems } from "@directus/sdk";
import directus from "@/lib/directus";
import { ReloadModel } from "@/constants";

export const depositService = {

    fetchDepositHistory: async (
        phoneNumber: string,
    ): Promise<{
        success: boolean;
        error?: Error;
        depots?: ReloadModel[];
    } | undefined> => {
        try {

            const currentDate = new Date();

            const date30DaysAgo = new Date();
            date30DaysAgo.setDate(currentDate.getDate() - 30);

            const date30DaysAgoISO = date30DaysAgo.toISOString();
            const currentDateISO = currentDate.toISOString();

            const depostList = await directus.request(readItems("depot", {
                filter: {
                    numero_commercial: {
                        _eq: phoneNumber,
                    },
                    date_created: {
                        _gte: date30DaysAgoISO,
                        _lte: currentDateISO,
                    },
                },
                sort: ['-date_created'],
            }));
            const depotsListToReturn = depostList as ReloadModel[];

            return {
                success: true,
                depots: depotsListToReturn,
            };

        } catch (error: any) {
            return {
                success: false,
                error: new Error(error.message || "Erreur lors de la récupération des dépôts"),
            };
        }
    },

};
